import { useTranslation } from 'react-i18next';
import LoginForm from '../../components/forms/loginForm';
import { LoginStore } from '../../stores/LoginStore';

type Props = {
  store: LoginStore
}
const Login = ({store}: Props) => {
  const { t } = useTranslation('login');
  return (
    <div className="wrap">
      <div className="container">
        <div className="main">
          <div className="mb-4">
            <p className="pStyle">{t('loginText')}</p>
          </div>
          <div className="grid">
              <LoginForm t={t} store={store} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
